module.exports = __webpack_public_path__ + "img/heizen-mit-holzpellets.d6a843a.webp";